import {Extension} from "@codemirror/state";
import {Diagnostic, linter} from "@codemirror/lint";
import {CheckSuccessReply} from "../../../shared/Types";
import styles from "../Editor.module.scss";
import CodeStore from "../../../state/codeStore";
import CompileStore from "../../../state/compileStore";

const linterExtension = (
	codeStore: CodeStore,
	compileStore: CompileStore
): Extension => [
	linter(
		async (view) => {
			const r: CheckSuccessReply | null = await compileStore.callDiagnosticsApi(
				codeStore.fileMap,
				codeStore.hiddenFileNames
			);
			if (!r) return [];

			const fullFileName = "StudentCode." + codeStore.focusedFile;
			const filesWithErrors: Set<string> = new Set(); // TODO: use for headers

			return r.diagnostics
				.filter((d) => {
					const fullName = d.fileName + ".java";
					filesWithErrors.add(fullName);
					return fullName === fullFileName;
				})
				.map(({type, message, start, end}): Diagnostic => {
					return {
						from: start,
						to: end,
						message,
						severity: type,
						renderMessage: (_view) => {
							const element = document.createElement("div");
							element.innerHTML = message;
							element.className = styles.errorFont;
							return element;
						},
					};
				});
		},
		{delay: 500}
	),
];

export default linterExtension;
